import api from '@http/api';

export interface IGetAllDocumentosTable {
  id: number;
  nome: string;
}

export interface IGetAllDocumentos {
  error: boolean;
  response?: IGetAllDocumentosTable[];
}

export interface IGetAllProjetos {
  id: number;
  nome: string;
}

export interface IGetAllProjetosDocumentos {
  documento: {
    id: number;
    descricao: string;
  }
}

export interface IGetAllDocumentos {
  id: number;
  descricao: string;
}

export interface IResponseDocumento {
  error: boolean;
}

export interface IAno {
  id: number;
  descricao: string;
}


class Services {
  public async GetAllProjetos() {
    return await api
      .get<IGetAllProjetos[]>(`/api/projetos/GetAll`)
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }

  public async GetAllDocumentos() {
    return await api
      .get<IGetAllDocumentos[]>(`/api/DocumentoIr/GetAll`)
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }

  public async CreateDocumento(req: any): Promise<IResponseDocumento> {
    return await api
      .post('/api/DocumentacaoProjetoIr/InserirDocumentoObrigatorio', req)
      .then(response => {
        return {
          error: false,
          //response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          //response: [],
        };
      });
  }

}

export default Services;
